import React, { useCallback, useState } from 'react';
import { StyledButton, Spinner, Text } from './styled';
import { SvgIconWrap } from '../icon-wrap';
import { StyledButtonProps } from '../types';
import { ButtonProps as MuiButtonProps } from '@mui/material';

export const Button = React.forwardRef<HTMLButtonElement, MuiButtonProps & StyledButtonProps>(
  (
    {
      children,
      type,
      variant,
      color,
      size,
      loading,
      fullWidth,
      startIcon,
      endIcon,
      radius,
      animation,
      animationType,
      animationTarget,
      ...restProps
    },
    ref
  ) => {
    const [isHover, setIsHover] = useState(false);

    const handleMouseEnter = useCallback(() => {
      setIsHover(true);
    }, []);

    const handleMouseLeave = useCallback(() => {
      setIsHover(false);
    }, []);

    return (
      <StyledButton
        {...restProps}
        type={type}
        variant={variant}
        color={color}
        size={size}
        fullWidth={fullWidth}
        ref={ref}
        loading={loading}
        radius={radius}
        startIcon={startIcon && <SvgIconWrap hover={isHover}>{startIcon}</SvgIconWrap>}
        endIcon={endIcon && <SvgIconWrap hover={isHover}>{endIcon}</SvgIconWrap>}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Text className={'text'}>{children}</Text>
        {loading && (
          <Spinner
            size={size === 'small' ? 16 : size === 'medium' ? 20 : 24}
            color={
              color
                ? variant === 'contained'
                  ? 'inherit'
                  : color === 'inherit'
                    ? 'secondary'
                    : color
                : `inherit`
            }
          />
        )}
      </StyledButton>
    );
  }
);
